// Structural deep equality for plain JSON-ish values (objects, arrays, primitives)
// plus Dates. Not specific to any one domain — used by provenance content comparison
// (core) and the reconciliation engine (viewmodel, where completion `at: Date` flows
// through), so it lives here in shared.
//
// Caveats: compares own enumerable keys; Dates are compared by their time value;
// other class instances (Map, Set, RegExp, …) are NOT deep-compared — they only
// match by reference, since the plain data we read back from Firestore/zod doesn't
// use them. `NaN !== NaN` follows `===` semantics.
export const deepEqual = (a, b) => {
    if (a === b)
        return true;
    if (typeof a !== "object" || typeof b !== "object" || a === null || b === null)
        return false;
    if (a instanceof Date || b instanceof Date) {
        return a instanceof Date && b instanceof Date && a.getTime() === b.getTime();
    }
    if (Array.isArray(a) || Array.isArray(b)) {
        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length)
            return false;
        return a.every((x, i) => deepEqual(x, b[i]));
    }
    const ak = Object.keys(a);
    const bk = Object.keys(b);
    if (ak.length !== bk.length)
        return false;
    return ak.every((k) => Object.prototype.hasOwnProperty.call(b, k) &&
        deepEqual(a[k], b[k]));
};
//# sourceMappingURL=deepEqual.js.map